import { render, staticRenderFns } from "./Created.vue?vue&type=template&id=3755b396&scoped=true"
import script from "./Created.vue?vue&type=script&lang=js"
export * from "./Created.vue?vue&type=script&lang=js"
import style0 from "./Created.vue?vue&type=style&index=0&id=3755b396&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3755b396",
  null
  
)

export default component.exports